import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PermissionsService } from 'src/app/service/auth/permissions.service';

@Component({
  selector: 'app-job-board-tags',
  templateUrl: './job-board-tags.component.html',
  styleUrls: ['./job-board-tags.component.scss'],
})
export class JobBoardTagsComponent implements OnInit {
  @Input() tag: any = {};
  @Input() removable: boolean = false;
  @Input() tagShape: any = {};
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private sanitizer: DomSanitizer,
    private permissionsService: PermissionsService,
  ) {}

  ngOnInit(): void {}

  deleteTag() {
    this.delete.emit(this.tag);
  }

  sanitizeSVGString(svg: string) {
    let safeSVG: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(svg);
    return safeSVG;
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      job_board_attributes: 'job_board_attributes',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }
}
